<template>
  <div>
    <widget heading="Course Plan">
      <b-form @submit.prevent="" class="mb-2">
        <b-input-group class="filter-group">
          <b-form-select v-model="selectedTimePeriodId"
                      :options="timePeriods"
                      value-field="timePeriodId"
                      text-field="description"
                      class="mb-2 mx-2"></b-form-select>
        </b-input-group>
        <b-button tag="a" class="pull-right" target="_blank" :href="link">Download CSV</b-button>
      </b-form>
    </widget>
  </div>
</template>

<script>
import { mapState } from "vuex";
import widget from "../../components/widget";
import reportsApi from "../../api/reports";
import timePeriodsApi from "../../api/timePeriods";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      summary: {},
      timePeriods: [],
      selectedTimePeriodId: null
    };
  },

  components: { widget },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    link() {
      return (
        process.env.VUE_APP_BASE_URI +
        "/api/WorkloadsReports/CoursePlan?timePeriodId=" +
        this.selectedTimePeriodId
      );
    }
  },

  methods: {
    getCoursePlan: function(timePeriodId) {
      reportsApi.getCoursePlan(timePeriodId).then(response => {
        this.summary = response.data;
      });
      //localStorage.timePeriodId = this.selectedTimePeriodId;
    }
  },

  created() {
    var that = this;

    timePeriodsApi.getTimePeriods().then(function(response) {
      that.timePeriods = response.data;
      // if (localStorage.timePeriodId) {
      //   that.selectedTimePeriodId = localStorage.timePeriodId;
      //   //that.getCoursePlan(that.selectedTimePeriodId);
      // } else {
      timePeriodsApi.getCurrentTimePeriod().then(function(response) {
        that.selectedTimePeriodId = response.data;
        //that.getCoursePlan(that.selectedTimePeriodId);
      });
      //}
    });
  }
};
</script>

<style scoped>
</style>
